import { useState, useCallback } from "react";
const isBrowser = () => typeof document !== "undefined";
const getCookie = (name) => {
  if (isBrowser()) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
  }
  return null;
};
const setCookie = (name, value, options) => {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  if (!(options == null ? void 0 : options.path)) {
    cookieString += "; path=/";
  }
  if (options) {
    if (options.expires) {
      const expires = new Date(options.expires);
      cookieString += `; expires=${expires.toUTCString()}`;
    }
    if (options.path) {
      cookieString += `; path=${options.path}`;
    }
    if (options.domain) {
      cookieString += `; domain=${options.domain}`;
    }
    if (options.secure) {
      cookieString += "; secure";
    }
    if (options.maxAge) {
      cookieString += `; max-age=${options.maxAge}`;
    }
  }
  if (isBrowser()) {
    document.cookie = cookieString;
  }
};
function useCookie(name, defaultValue) {
  const [value, setValue] = useState(() => {
    const cookieValue = getCookie(name);
    if (cookieValue) {
      return cookieValue;
    }
    if (defaultValue) {
      setCookie(name, defaultValue);
    }
    return defaultValue;
  });
  const updateCookie = useCallback(
    (newValue, options) => {
      setCookie(name, newValue, options);
      setValue(newValue);
    },
    [name]
  );
  const deleteCookieByName = useCallback((name2) => {
    setCookie(name2, "", { expires: /* @__PURE__ */ new Date(0) });
  }, []);
  const deleteCookie = useCallback(() => {
    deleteCookieByName(name);
    setValue(void 0);
  }, [name, deleteCookieByName]);
  return [value, updateCookie, deleteCookie];
}
export {
  useCookie
};
